import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';
import {
    contentStylesByError,
    contentStylesByDimension,
    contentStylesByDisabled,
    textStylesByDimension,
} from './file.mixins';
import { FileDimension } from '../input-file/types';

export const Wrapper = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 8px;
`;

export const Content = styled('div')<{ dimension: FileDimension; isError?: boolean; disabled?: boolean }>`
    position: relative;
    display: flex;
    border-radius: 12px;
    align-items: center;
    gap: 8px;
    background: ${COLORS.neutral_05};

    ${contentStylesByDisabled}
    ${contentStylesByError}
    ${contentStylesByDimension}
`;

export const TextWrapper = styled('div')`
    display: flex;
    align-items: flex-start;
    align-self: stretch;
    flex-grow: 1;
    ${textStylesByDimension}
`;

export const IconWrapper = styled('div')<{ dimension: FileDimension }>`
    display: ${({ dimension }) => (dimension === 'l' ? 'block' : 'none')};
    flex-shrink: 0;
    width: 40px;
    height: 40px;
`;

export const CloseWrapper = styled('div')<{ disabled?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    ${({ disabled }) => (disabled ? '' : 'cursor: pointer;')}
    color: ${COLORS.neutral_50};
    z-index: 1;
`;

export const DisableCover = styled('div')`
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border-radius: 12px;
    background: ${COLORS.neutral_00};
    opacity: 0.55;
`;

export const PreloaderWrapper = styled('div')`
    position: relative;
    width: 24px;
    height: 24px;
    z-index: 0;
`;
